'use client';
import { cn } from '@bells/core/lib/utils';
import { type PropsWithChildren, useEffect, useState } from 'react';

export const HeaderFrame = ({
  className,
  children,
}: PropsWithChildren<{ className?: string }>) => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <header
      data-scroll={scrollPosition > 0 ? 'true' : 'false'}
      className={cn(
        'sticky top-0 z-20 flex h-[58px] shrink-0 items-center gap-2 overflow-hidden border-b bg-background/95 text-foreground backdrop-blur duration-0 supports-[backdrop-filter]:bg-background/60',
        className
      )}
    >
      {children}
    </header>
  );
};
